module.exports={
	"Form": "TestSpecificationSetEditManifest",
	"Scope": "TestSpecificationSet-Edit",
	"Descriptors":
	{
		"TestSpecificationSetDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationSet-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationSet-Edit-Identity",
				"Group": "TestSpecificationSet-Edit-Identity"
			}
		},
		"TestSpecificationSetDetails.Year":
		{
			"Name": "Year",
			"Hash": "TestSpecificationSet-Edit-Year",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-Details",
				"Group": "TestSpecificationSet-Edit-Details"
			}
		},
		"TestSpecificationSetDetails.IDTestSpecificationSet":
		{
			"Name": "IDTest Specification Set",
			"Hash": "TestSpecificationSet-Edit-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.GUIDTestSpecificationSet":
		{
			"Name": "GUIDTest Specification Set",
			"Hash": "TestSpecificationSet-Edit-GUIDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecificationSet-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecificationSet-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecificationSet-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		},
		"TestSpecificationSetDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecificationSet-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationSet-Edit-DataAudit",
				"Group": "TestSpecificationSet-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationSet-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationSet-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationSet-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationSet-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecificationSet-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecificationSet-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
